import { useEffect, useState } from "react";

import { type ScriptStatuses, useScript } from "@ui/hooks/useScript";

type UseKakao = ({
  kakaoSdkLink,
  integrityKey,
  sdkKey,
  isEnabled,
}: {
  kakaoSdkLink: string;
  integrityKey: string;
  sdkKey: string;
  isEnabled?: boolean;
}) => {
  scriptStatus: ScriptStatuses;
  isScriptInitiated: boolean;
  isInitiationFailed: boolean;
};

export const useKakao: UseKakao = ({ kakaoSdkLink, integrityKey, sdkKey, isEnabled = true }) => {
  const [isScriptInitiated, setIsScriptInitiated] = useState(false);
  const [isInitiationFailed, setIsInitiationFailed] = useState(false);

  const hasKakaoSdkConfig = Boolean(kakaoSdkLink && integrityKey);
  const shouldLoadKakaoSdk = isEnabled && hasKakaoSdkConfig;

  if (isEnabled && !hasKakaoSdkConfig) {
    console.warn("useKakao is enabled but kakaoSdkLink or integrityKey is missing");
  }

  const { scriptStatus } = useScript({
    scriptSrc: kakaoSdkLink,
    attributes: {
      integrity: integrityKey,
      crossOrigin: "anonymous",
    },
    isEnabled: shouldLoadKakaoSdk,
  });

  useEffect(() => {
    if (!isEnabled || scriptStatus !== "ready" || !window.Kakao) return;

    try {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(sdkKey);
      }

      setIsScriptInitiated(true);
    } catch (error) {
      console.error(error);
      setIsInitiationFailed(true);
    }
  }, [scriptStatus, sdkKey, isEnabled]);

  return {
    scriptStatus,
    isScriptInitiated,
    isInitiationFailed,
  };
};
